import { ProductAdditives } from '../../../../services/exports/Constants';

export default {
  title: 'Dodatki',
  options: {
    [ProductAdditives.AcesulfamK]: 'Acesulfam K',
    [ProductAdditives.AceSucralose]: 'Ace-Sukraloza',
    [ProductAdditives.Aesculin]: 'Eskulina',
    [ProductAdditives.Agar]: 'Agar',
    [ProductAdditives.Anthocyanin]: 'Antocyjan',
    [ProductAdditives.Antioxidant]: 'Przeciwutleniacz',
    [ProductAdditives.AntioxidantAscorbicAcid]: 'Przeciwutleniacz: Kwas askorbinowy',
    [ProductAdditives.AntioxidantTocopherols]: 'Przeciwutleniacz: Tokoferole',
    [ProductAdditives.Flavor]: 'Aromat',
    [ProductAdditives.Flavors]: 'Aromaty',
    [ProductAdditives.AscorbicAcid]: 'Kwas askorbinowy',
    [ProductAdditives.Aspartame]: 'Aspartam',
    [ProductAdditives.OysterSauce]: 'Sos ostrygowy',
    [ProductAdditives.BakingAid]: 'Środek do pieczenia',
    [ProductAdditives.BakingPowder]: 'Proszek do pieczenia',
    [ProductAdditives.BalsamicVinegar]: 'Ocet balsamiczny',
    [ProductAdditives.BalsamicCream]: 'Krem balsamiczny',
    [ProductAdditives.BasilPesto]: 'Pesto bazyliowe',
    [ProductAdditives.BenzoicAcid]: 'Kwas benzoesowy',
    [ProductAdditives.BetaCarotene]: 'Beta-karoten',
    [ProductAdditives.Betain]: 'Betaina',
    [ProductAdditives.BeetrootRed]: 'Czerwień buraczana',
    [ProductAdditives.Beeswax]: 'Wosk pszczeli',
    [ProductAdditives.Bitters]: 'Bitters',
    [ProductAdditives.BlueCuracao]: 'Blue Curaçao',
    [ProductAdditives.BlueCuracaoSyrup]: 'Syrop Blue Curaçao',
    [ProductAdditives.BrandyVinegar]: 'Ocet z brandy',
    [ProductAdditives.Broth]: 'Bulion',
    [ProductAdditives.Caffeine]: 'Kofeina',
    [ProductAdditives.Calcium]: 'Wapń',
    [ProductAdditives.Caramel]: 'Karmel',
    [ProductAdditives.CaramelColor]: 'Barwnik karmelowy',
    [ProductAdditives.CaramelE150d]: 'Karmel E150d',
    [ProductAdditives.Carotene]: 'Karoten',
    [ProductAdditives.CayennePepper]: 'Pieprz cayenne',
    [ProductAdditives.Chili]: 'Chili',
    [ProductAdditives.ChiliDressing]: 'Dressing chili',
    [ProductAdditives.ChiliMayonnaise]: 'Majonez chili',
    [ProductAdditives.ChiliOil]: 'Olej chili',
    [ProductAdditives.Quinine]: 'Chinina',
    [ProductAdditives.Chlorophyll]: 'Chlorofil',
    [ProductAdditives.CitricAcid]: 'Kwas cytrynowy',
    [ProductAdditives.CitrusAcid]: 'Kwas cytrusowy',
    [ProductAdditives.CarbonDioxide]: 'Dwutlenek węgla (CO₂)',
    [ProductAdditives.CocktailSauce]: 'Sos koktajlowy',
    [ProductAdditives.Curry]: 'Curry',
    [ProductAdditives.CurryPaste]: 'Pasta curry',
    [ProductAdditives.CurryPowder]: 'Proszek curry',
    [ProductAdditives.CurryCreamSauce]: 'Kremowy sos curry',
    [ProductAdditives.Fragrance]: 'Zapach',
  },
};
